export const transports = {
  methods: {
    checkTracking: (partner, communicationStatus = null) => {
      const partners = ['DHL', 'CTT', 'LOGIC']
      const check = partners.includes(partner.toUpperCase().trim())

      if (!communicationStatus) return check
      if (partner !== 'LOGIC') return check && communicationStatus === 'REPORTED'
    },
    checkPartner: partner => {
      const partnersToExclude = [
        'N.A.',
        'CARRO DEDICADO',
        'GRUA',
        'GRUA DEDICADO',
        'PARCEIRO CODIGO POSTAL'
      ]

      return !partnersToExclude.includes(partner.toUpperCase().trim())
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/transports.js